<div class="scroll">
  <div class="content">
    <div class="hero container">
      <div class="column is-8 is-offset-2">
        <div class="container has-text-centered">
          <img src="assets/caddie_logo.png" />
          <h2 class="subtitle is-3">Cancer Driver Drug Interaction Explorer</h2>
        </div>
        <div class="content">
          <p>
            <br />
            The Cancer Driver Drug Interaction Explorer (CADDIE) is a systems
            medicine platform which uses network biology algorithms for drug
            repurposing in cancer. A variety of different data resources have
            been implemented for cancer driver gene information as well as
            interaction data for gene-gene interactions and gene-drug
            interactions. We further integrated genetical background data like
            related diseases and mutation data to improve the algorithms and to
            facilitate the interpretation of the results.
            <br />
            We provide a user friendly graphical interface which allows to
            inspect and to understand the biological context of the predictions.
            CADDIE can be used to repurpose drugs as well as to find new drug
            targets.
          </p>
          <div class="has-text-centered">
            <h2 class="subtitle">General workflow of the platform</h2>
          </div>
          <div class="container has-text-centered width-500">
            <img
              src="assets/workflow.png"
              alt="CADDIE workflow"
              title="General workflow of CADDIE"
            />
          </div>
          <ol>
            <li>
              Choose which source should be used for cancer driver genes,
              gene-gene interactions as well as which cancer type should be
              highlighted.
            </li>
            <li>
              Select seed nodes in the network. The algorithms will find
              putative drug-targets or drugs based on these seed nodes.
            </li>
            <li>
              Run the analysis on our server and inspect the results as soon as
              it is done. A network visualization helps to interpret the results
              and all data can be downloaded for further processing.
            </li>
          </ol>

          <!--          <h2>Source code</h2>-->
          <!--          <p>-->
          <!--            The source code is available upon request: michael.hartung@tum.de-->
          <!--          </p>-->

          <br />
          <br />
          
          <div class="has-text-centered">
            <h2>Contact Information</h2>
          </div>
          <p>
            For further questions, suggestions or general feedback, please
            contact:
          </p>
          <div>
            <i class="fa fa-envelope"> </i> Email:
            <a
              href="mailto:michael.hartung@uni-hamburg.de"
              title="michael.hartung@uni-hamburg.de"
              >michael.hartung@uni-hamburg.de</a
            >
          </div>
          <br />
          <br />
          <a id="data-privacy-disclaimer"></a>
          <div class="has-text-centered">
            <h2>Data Privacy</h2>
          </div>
          <p>
            This website only stores data to provide full functionality to the
            user. Upon starting an analysis task in the explorer, a task
            identification string is anonymously stored in your browser. This
            enables you to revisit previous analysis tasks without storing the
            URLs and to select tasks to summarize them. When removing the data
            of this website, previous analysis tasks will not appear in the task
            list anymore.
            <br />
            This website uses no cookies or tracks of user data in any way.
          </p>
          <br />
          <br />
          <div class="has-text-centered">
            <h2>Impressum</h2>
          </div>
          <div>
            <p>
              This project is a cooperation between the chair of Computational
              Systems Biology from the University of Hamburg and the research
              group Big Data in Biomedicine from the Technical University of
              Munich.
            </p>
          </div>
          <br />

          <div>
            <p>
              <b>Prof. Dr. Jan Baumbach</b><br />
              Chair of Computational Systems Biology
              <br />
              <i class="fa fa-phone"></i> Phone: +49-8161-71-2136<br />
              <i class="fa fa-envelope"></i> Email: cosyb@zbh.uni-hamburg.de<br />
              <i class="fa fa-link"></i>
              <a href="https://www.cosy.bio/">https://www.cosy.bio/</a><br />
              Chair of Computational Systems Biology
              <br />
              University of Hamburg
              <br />
              Notkestrasse 9<br />
              22607 Hamburg<br />
              Germany
            </p>
          </div>
          <br />

          <div>
            <p>
              <b>Dr. Markus List</b><br />
              Head of the Research Group Big Data in BioMedicine
              <br />
              <i class="fa fa-phone"></i> Phone: +49 8161 71 2761<br />
              <i class="fa fa-envelope"> </i> Email: markus.list@wzw.tum.de<br />
              <i class="fa fa-link"></i>
              <a href="https://biomedical-big-data.de/"
                >https://biomedical-big-data.de/</a
              ><br />
              Chair of Experimental Bioinformatics<br />
              TUM School of Life Sciences Weihenstephan<br />
              Technical University of Munich<br />
              Maximus-von-Imhof-Forum 3<br />
              85354 Freising<br />
              Germany<br />
            </p>
          </div>

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
